import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { createBibFieldSelector } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { fieldShape } from 'app/shapes/bibPage';
import Notes from './Notes';

const CATEGORY = 'NOTES';
const selectNotes = createBibFieldSelector(CATEGORY);

export class NotesContainer extends React.PureComponent {
  render() {
    const { fields, trackFieldItemClick } = this.props;

    return fields?.size ? (
      <Notes
        fields={fields}
        trackFieldItemClick={(fieldItem, fieldValue) => trackFieldItemClick(CATEGORY, fieldItem, fieldValue)}
      />
    ) : null;
  }
}

NotesContainer.propTypes = {
  fields: ImmutablePropTypes.listOf(fieldShape).isRequired,
  trackFieldItemClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  fields: selectNotes(state)
});

export default connect(mapStateToProps)(NotesContainer);
